import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import {
    cellyticsAnalysisDataUrl,
    cellyticsAnalysisSet,
    cellyticsCurrentAnalysisSetId,
    cellyticsDefaultAnalysisSet,
    cellyticsRecommendedCaseId,
} from '../cellytics-analysis';

const ACCESS_SESSION_KEY = "cellytics.access";
const ACCESS_SESSION_VALUE = "granted";
const ACCESS_USER = {
    id: "cellytics-access",
    email: "",
    name: "Cellytics NK",
    role: "admin",
};

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    public analysis: any = null;
    public analysisSetId: string = "";
    public analysisSet: any = null;
    public loading: boolean = true;
    public error: string = "";
    public selectedSampleId: string = "";
    public selectedCaseId: string = "background_blur_mmd_filter";
    public comparisonBaseCaseId: string = "original";
    public comparisonTargetCaseId: string = "background_blur_mmd_filter";
    public activeSection: string = "overview";
    public classificationFilter: string = "all";
    public imageModal: any = null;
    public dashboardSections: any[] = [
        { id: "overview", label: "요약" },
        { id: "subjects", label: "정상/환자", requiresSubjects: true },
        { id: "correlation", label: "상관 분석" },
    ];
    public analytics: any = {
        correlation: this.emptyCorrelation("MMD_STD", "WSM_STD"),
        cspCorrelation: this.emptyCorrelation("MMD_STD", "CSP"),
    };

    public metricRows: any[] = [
        { key: "CMV", label: "CMV" },
        { key: "PPD", label: "PPD" },
        { key: "MMD", label: "MMD" },
        { key: "MMD_SD", label: "MMD_STD" },
        { key: "WCM", label: "WCM" },
        { key: "WCM_SD", label: "WCM_STD" },
        { key: "WSM", label: "WSM" },
        { key: "WSM_SD", label: "WSM_STD" },
        { key: "CSP", label: "CSP" },
    ];

    public comparisonRows: any[] = [
        { key: "finalCount", label: "최종 cell", digits: 0, source: "case" },
        { key: "mmdRejected", label: "MMD 제외", digits: 0, source: "case" },
        { key: "overlapRejected", label: "Overlap 제외", digits: 0, source: "case" },
        { key: "CMV", label: "CMV", digits: 2, source: "metrics" },
        { key: "PPD", label: "PPD", digits: 2, source: "metrics" },
        { key: "MMD", label: "MMD", digits: 2, source: "metrics" },
        { key: "MMD_SD", label: "MMD_STD", digits: 2, source: "metrics" },
        { key: "WCM", label: "WCM", digits: 2, source: "metrics" },
        { key: "WCM_SD", label: "WCM_STD", digits: 2, source: "metrics" },
        { key: "WSM", label: "WSM", digits: 2, source: "metrics" },
        { key: "WSM_SD", label: "WSM_STD", digits: 2, source: "metrics" },
        { key: "CSP", label: "CSP", digits: 2, source: "metrics" },
    ];
    public classificationFilterOptions: any[] = [
        { id: "all", label: "전체" },
        { id: "normal", label: "정상군" },
        { id: "patient", label: "환자군" },
    ];

    private routerSub: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.hasAccess()) {
            location.href = "/access";
            return;
        }
        this.applyAccessSession();
        this.syncAnalysisSet();
        this.bindRouteChanges();
        await this.load();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private hasAccess() {
        return this.service.auth.check() || window.sessionStorage.getItem(ACCESS_SESSION_KEY) === ACCESS_SESSION_VALUE;
    }

    private applyAccessSession() {
        if (this.service.auth.check()) return;
        this.service.auth.status = true;
        this.service.auth.session = ACCESS_USER;
    }

    private syncAnalysisSet() {
        this.analysisSetId = cellyticsCurrentAnalysisSetId();
        this.analysisSet = cellyticsAnalysisSet(this.analysisSetId) || cellyticsDefaultAnalysisSet();
    }

    private bindRouteChanges() {
        if (this.routerSub) return;
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (!(event instanceof NavigationEnd)) return;
            const nextSetId = cellyticsCurrentAnalysisSetId();
            if (nextSetId === this.analysisSetId) return;
            this.syncAnalysisSet();
            await this.load();
        });
    }

    public async load() {
        this.syncAnalysisSet();
        this.loading = true;
        this.error = "";
        await this.service.render();

        try {
            const response = await fetch(cellyticsAnalysisDataUrl(this.analysisSetId), { cache: "no-cache" });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            this.analysis = await response.json();
            this.analytics = this.buildAnalytics();
            this.selectedSampleId = this.samples[0]?.id || "";
            const recommendedCaseId = cellyticsRecommendedCaseId(this.analysisSetId);
            this.selectedCaseId = this.findCase(recommendedCaseId) ? recommendedCaseId : (this.cases[0]?.id || "");
            this.comparisonBaseCaseId = this.findCase("original") ? "original" : (this.cases[0]?.id || "");
            this.comparisonTargetCaseId = this.findCase(recommendedCaseId) ? recommendedCaseId : (this.cases[1]?.id || this.cases[0]?.id || "");
        } catch (error) {
            this.error = "분석 데이터를 불러오지 못했습니다.";
        }

        this.loading = false;
        await this.service.render();
    }

    public get samples() {
        return this.analysis?.samples || [];
    }

    public get cases() {
        return this.analysis?.cases || [];
    }

    public get blurMethodAnalysis() {
        return this.analysis?.blurMethodAnalysis || null;
    }

    public get visibleDashboardSections() {
        return this.dashboardSections.filter((section: any) => !section.requiresSubjects || this.hasClassification);
    }

    public get subjectSummary() {
        return this.analysis?.subjectSummary || [];
    }

    public get sampleGroupSummary() {
        return this.analysis?.sampleGroupSummary || [];
    }

    public get classificationRows() {
        return this.sampleGroupSummary.length ? this.sampleGroupSummary : this.subjectSummary;
    }

    public get filteredClassificationRows() {
        if (this.classificationFilter === "all") return this.classificationRows;
        return this.classificationRows.filter((row: any) => row.diagnosis === this.classificationFilter);
    }

    public get classificationStepColumns() {
        return this.singleStepSummary.filter((row: any) => !!row.caseId);
    }

    public get hasSampleGroups() {
        return this.sampleGroupSummary.length > 0;
    }

    public get classificationTitle() {
        return this.hasSampleGroups ? "샘플 정상/환자군 목록" : "피험자 정상/환자 확인";
    }

    public get classificationDescription() {
        if (this.hasSampleGroups) {
            const backgroundText = this.analysis?.analysisSet?.backgroundAvailable === false
                ? "autoled 폴더가 없어 background subtraction은 적용하지 않았습니다."
                : "분석 세트의 background subtraction 가능 여부를 반영했습니다.";
            return `샘플번호, 질병명, 반복구수 기준으로 ${backgroundText}`;
        }
        return "피험자별 정상/환자 라벨과 단일 전처리 적용 결과를 확인합니다.";
    }

    public get diagnosisSummary() {
        return this.analysis?.diagnosisSummary || [];
    }

    public get singleStepSummary() {
        return this.analysis?.singleStepSummary || [];
    }

    public get hasClassification() {
        return this.classificationRows.length > 0;
    }

    public get selectedSingleStepRows() {
        return this.singleStepSummary.map((row: any) => ({
            ...row,
            selectedCase: this.sampleCase(this.selectedSample, row.caseId),
        }));
    }

    public get selectedSample() {
        return this.samples.find((sample: any) => sample.id === this.selectedSampleId) || this.samples[0] || null;
    }

    private isTrustedNative(sample: any = this.selectedSample) {
        return sample?.nativeVerified === true;
    }

    public get selectedCase() {
        if (!this.selectedSample) return null;
        return this.sampleCase(this.selectedSample, this.selectedCaseId) || this.selectedSample.cases[0] || null;
    }

    public get baselineCase() {
        if (!this.selectedSample) return null;
        return this.sampleCase(this.selectedSample, "original");
    }

    public get selectedComparisonBase() {
        if (!this.selectedSample) return null;
        return this.sampleCase(this.selectedSample, this.comparisonBaseCaseId) || this.baselineCase || this.selectedSample.cases[0] || null;
    }

    public get selectedComparisonTarget() {
        if (!this.selectedSample) return null;
        return this.sampleCase(this.selectedSample, this.comparisonTargetCaseId) || this.selectedCase || this.selectedSample.cases[0] || null;
    }

    public findCase(caseId: string) {
        return this.cases.find((row: any) => row.id === caseId);
    }

    public sampleCase(sample: any, caseId: string) {
        return sample?.cases?.find((row: any) => row.caseId === caseId) || null;
    }

    public async selectSample(sampleId: string) {
        this.selectedSampleId = sampleId;
        await this.service.render();
    }

    public async selectCase(caseId: string) {
        this.selectedCaseId = caseId;
        await this.service.render();
    }

    public async selectComparisonBase(caseId: string) {
        this.comparisonBaseCaseId = caseId;
        await this.service.render();
    }

    public async selectComparisonTarget(caseId: string) {
        this.comparisonTargetCaseId = caseId;
        await this.service.render();
    }

    public async selectSection(sectionId: string) {
        this.activeSection = sectionId;
        await this.service.render();
    }

    public async selectClassificationFilter(filterId: string) {
        this.classificationFilter = filterId;
        await this.service.render();
    }

    public sectionActiveClass(sectionId: string) {
        if (this.activeSection === sectionId) {
            return "rounded-lg border border-emerald-500 bg-emerald-50 px-3 py-2 text-[12px] font-semibold text-emerald-800";
        }
        return "rounded-lg border border-gray-200 bg-white px-3 py-2 text-[12px] font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50";
    }

    public classificationFilterClass(filterId: string) {
        if (this.classificationFilter === filterId) {
            return "rounded-md border border-emerald-500 bg-emerald-50 px-3 py-1.5 text-[12px] font-semibold text-emerald-800";
        }
        return "rounded-md border border-gray-200 bg-white px-3 py-1.5 text-[12px] font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50";
    }

    public sampleActiveClass(sampleId: string) {
        if (this.selectedSampleId === sampleId) {
            return "flex items-center justify-between gap-3 rounded-lg border border-emerald-500 bg-emerald-50 px-3 py-2 text-left text-[13px] font-semibold text-emerald-800";
        }
        return "flex items-center justify-between gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-[13px] font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50";
    }

    public caseActiveClass(caseId: string) {
        if (this.selectedCaseId === caseId) {
            return "rounded-lg border border-emerald-500 bg-emerald-50 px-3 py-2 text-left text-[12px] font-semibold text-emerald-800";
        }
        return "rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-[12px] font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50";
    }

    public diagnosisClass(diagnosis: string) {
        if (diagnosis === "normal") return "rounded bg-emerald-50 px-1.5 py-0.5 text-[10px] font-semibold text-emerald-700";
        if (diagnosis === "patient") return "rounded bg-rose-50 px-1.5 py-0.5 text-[10px] font-semibold text-rose-700";
        return "rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-semibold text-gray-500";
    }

    public subjectStep(subject: any, caseId: string) {
        return subject?.singleSteps?.find((row: any) => row.caseId === caseId) || null;
    }

    public assayText(subject: any) {
        return (subject?.assays || []).map((row: any) => `${row.label} ${row.count}`).join(" / ");
    }

    public replicateText(row: any) {
        if (row?.replicate) return row.replicate;
        return (row?.replicates || []).map((item: any) => `${item.label} ${item.count}`).join(" / ") || "-";
    }

    public deltaClass(value: any) {
        if (value > 0) return "text-blue-700";
        if (value < 0) return "text-red-600";
        return "text-gray-500";
    }

    public signed(value: any, digits: number = 0) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
        const numberValue = Number(value);
        const prefix = numberValue > 0 ? "+" : "";
        return `${prefix}${this.format(numberValue, digits)}`;
    }

    public format(value: any, digits: number = 0) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
        return Number(value).toLocaleString("ko-KR", {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        });
    }

    public metric(row: any, key: string) {
        if (!row || !row.metrics) return null;
        return row.metrics[key];
    }

    public comparisonValue(row: any, caseRow: any) {
        if (!row || !caseRow) return null;
        if (row.source === "metrics") return this.metric(caseRow, row.key);
        return caseRow[row.key];
    }

    public comparisonDelta(row: any) {
        const baseValue = this.comparisonValue(row, this.selectedComparisonBase);
        const targetValue = this.comparisonValue(row, this.selectedComparisonTarget);
        if (baseValue === null || baseValue === undefined || targetValue === null || targetValue === undefined) return null;
        return Number(targetValue) - Number(baseValue);
    }

    public comparisonDeltaPercent(row: any) {
        const baseValue = this.comparisonValue(row, this.selectedComparisonBase);
        const delta = this.comparisonDelta(row);
        if (!baseValue || delta === null || delta === undefined) return null;
        return (delta / Number(baseValue)) * 100;
    }

    public caseImage(row: any) {
        const fullImage = row?.fullImage || (row?.caseId === "original" ? this.selectedSample?.originalFullImage : "");
        const downloadImage = row?.downloadImage || (row?.caseId === "original" ? this.selectedSample?.originalDownloadImage : "");
        return this.imageRef(
            row?.preview,
            fullImage,
            downloadImage,
            fullImage ? (row?.nativeWidth || this.selectedSample?.width) : null,
            fullImage ? (row?.nativeHeight || this.selectedSample?.height) : null,
            this.isTrustedNative(),
        );
    }

    private imageRef(preview: string, fullImage: string = "", downloadImage: string = "", nativeWidth: any = null, nativeHeight: any = null, trustedNative: boolean = false) {
        const resolvedPreview = preview || fullImage || downloadImage || "";
        const useNative = trustedNative && !!fullImage && !!nativeWidth && !!nativeHeight;
        const resolvedFull = useNative ? fullImage : resolvedPreview;
        const resolvedDownload = useNative ? (downloadImage || resolvedFull) : "";

        return {
            preview: resolvedPreview,
            fullImage: resolvedFull,
            downloadImage: resolvedDownload,
            nativeWidth: useNative ? nativeWidth : null,
            nativeHeight: useNative ? nativeHeight : null,
            nativeTrusted: useNative,
        };
    }

    private resolveImageInput(input: any) {
        if (typeof input === "string") return this.imageRef(input);
        return this.imageRef(
            input?.preview || input?.src || input?.source || "",
            input?.fullImage || input?.full || input?.sourceFull || "",
            input?.downloadImage || input?.download || input?.sourceDownload || "",
            input?.nativeWidth || null,
            input?.nativeHeight || null,
            input?.nativeTrusted === true,
        );
    }

    private modalFileName(title: string, src: string) {
        const ext = (src || "").split("?")[0].split(".").pop() || "jpg";
        const safeTitle = (title || "cellytics-image")
            .replace(/[^0-9A-Za-z._-]+/g, "_")
            .replace(/^_+|_+$/g, "") || "cellytics-image";
        return safeTitle.endsWith(`.${ext}`) ? safeTitle : `${safeTitle}.${ext}`;
    }

    public async openImageModal(input: any, title: string, caption: string = "") {
        const image = this.resolveImageInput(input);
        const src = image.fullImage || image.preview;
        this.imageModal = {
            src,
            preview: image.preview,
            download: image.downloadImage || "",
            filename: this.modalFileName(title, src),
            nativeWidth: image.nativeWidth,
            nativeHeight: image.nativeHeight,
            usingNative: !!image.nativeWidth && !!image.nativeHeight,
            title,
            caption,
        };
        await this.service.render();
    }

    public async closeImageModal() {
        this.imageModal = null;
        await this.service.render();
    }

    private buildAnalytics() {
        return {
            correlation: this.buildSingleCellCorrelation("MMD_SD", "WSM_SD", "MMD_STD", "WSM_STD"),
            cspCorrelation: this.buildSingleCellCorrelation("MMD_SD", "CSP", "MMD_STD", "CSP"),
        };
    }

    private emptyCorrelation(xLabel: string, yLabel: string) {
        return {
            coefficient: null,
            pValue: null,
            rSquared: null,
            n: 0,
            strength: "데이터 부족",
            significance: "데이터 부족",
            points: [],
            xMin: null,
            xMax: null,
            yMin: null,
            yMax: null,
            xTicks: [],
            yTicks: [],
            trendLine: null,
            svg: { width: 640, height: 340, left: 72, right: 24, top: 28, bottom: 58 },
            xLabel,
            yLabel,
        };
    }

    private buildSingleCellCorrelation(xMetric: string, yMetric: string, xLabel: string, yLabel: string) {
        const rawPoints = this.samples
            .flatMap((sample: any) => {
                const original = this.sampleCase(sample, "original");
                return (original?.cellMetrics || []).map((cell: any) => ({
                    sampleName: sample.name,
                    cellIndex: cell.index,
                    xValue: this.numberValue(cell[xMetric]),
                    yValue: this.numberValue(cell[yMetric]),
                    csp: this.numberValue(cell.CSP),
                }));
            })
            .filter((row: any) => row.xValue !== null && row.yValue !== null)
            .map((row: any) => ({ ...row, xValue: Number(row.xValue), yValue: Number(row.yValue) }));

        if (!rawPoints.length) return this.emptyCorrelation(xLabel, yLabel);

        const svg = { width: 640, height: 340, left: 72, right: 24, top: 28, bottom: 58 };
        const xValues: number[] = rawPoints.map((row: any) => row.xValue);
        const yValues: number[] = rawPoints.map((row: any) => row.yValue);
        const xDomain = this.paddedDomain(xValues);
        const yDomain = this.paddedDomain(yValues);
        const xMin = xDomain.min;
        const xMax = xDomain.max;
        const yMin = yDomain.min;
        const yMax = yDomain.max;
        const coefficient = this.pearson(rawPoints.map((row: any) => [row.xValue, row.yValue]));
        const pValue = this.pearsonPValue(coefficient, rawPoints.length);
        const regression = this.linearRegression(rawPoints.map((row: any) => [row.xValue, row.yValue]));
        const xTicks = this.buildTicks(xMin, xMax, 5).map((value: number) => ({ value, x: this.scaleSvgX(value, xMin, xMax, svg) }));
        const yTicks = this.buildTicks(yMin, yMax, 5).map((value: number) => ({ value, y: this.scaleSvgY(value, yMin, yMax, svg) }));
        const points = rawPoints.map((row: any) => ({
            ...row,
            x: this.scaleSvgX(row.xValue, xMin, xMax, svg),
            y: this.scaleSvgY(row.yValue, yMin, yMax, svg),
            label: `${row.sampleName} #${row.cellIndex} / ${xLabel} ${this.format(row.xValue, 2)} / ${yLabel} ${this.format(row.yValue, 2)} / CSP ${this.format(row.csp, 2)}`,
        }));
        const trendLine = regression ? {
            x1: this.scaleSvgX(xMin, xMin, xMax, svg),
            y1: this.scaleSvgY(regression.slope * xMin + regression.intercept, yMin, yMax, svg),
            x2: this.scaleSvgX(xMax, xMin, xMax, svg),
            y2: this.scaleSvgY(regression.slope * xMax + regression.intercept, yMin, yMax, svg),
        } : null;

        return {
            coefficient,
            pValue,
            rSquared: coefficient === null ? null : coefficient * coefficient,
            n: rawPoints.length,
            strength: this.describeCorrelation(coefficient),
            significance: this.describePValue(pValue),
            points,
            xMin,
            xMax,
            yMin,
            yMax,
            xTicks,
            yTicks,
            trendLine,
            svg,
            xLabel,
            yLabel,
        };
    }

    private numberValue(value: any) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
        return Number(value);
    }

    private average(values: number[]) {
        if (!values.length) return null;
        return values.reduce((sum: number, value: number) => sum + value, 0) / values.length;
    }

    private pearson(points: any[]) {
        if (points.length < 2) return null;
        const xAverage = this.average(points.map((point: any) => point[0]));
        const yAverage = this.average(points.map((point: any) => point[1]));
        if (xAverage === null || yAverage === null) return null;
        let numerator = 0;
        let xSum = 0;
        let ySum = 0;
        for (const [x, y] of points) {
            numerator += (x - xAverage) * (y - yAverage);
            xSum += Math.pow(x - xAverage, 2);
            ySum += Math.pow(y - yAverage, 2);
        }
        if (!xSum || !ySum) return null;
        return numerator / Math.sqrt(xSum * ySum);
    }

    private describeCorrelation(value: number | null) {
        if (value === null || value === undefined) return "데이터 부족";
        const absolute = Math.abs(value);
        if (absolute < 0.2) return "뚜렷한 상관 낮음";
        const direction = value >= 0 ? "양의" : "음의";
        if (absolute >= 0.7) return `강한 ${direction} 상관`;
        if (absolute >= 0.4) return `중간 수준 ${direction} 상관`;
        return `약한 ${direction} 상관`;
    }

    private describePValue(value: number | null) {
        if (value === null || value === undefined) return "p-value 계산 불가";
        if (value < 0.001) return "p < 0.001";
        if (value < 0.05) return "통계적으로 유의";
        return "통계적으로 유의하지 않음";
    }

    private paddedDomain(values: number[]) {
        const min = Math.min(...values);
        const max = Math.max(...values);
        const range = max - min;
        const pad = range ? range * 0.16 : Math.max(Math.abs(max) * 0.08, 1);
        return { min: min - pad, max: max + pad };
    }

    private buildTicks(min: number, max: number, count: number) {
        if (count <= 1) return [min];
        const step = (max - min) / (count - 1);
        return Array.from({ length: count }, (_: any, index: number) => min + step * index);
    }

    private scaleSvgX(value: number, min: number, max: number, svg: any) {
        const width = svg.width - svg.left - svg.right;
        if (min === max) return svg.left + width / 2;
        return svg.left + ((value - min) / (max - min)) * width;
    }

    private scaleSvgY(value: number, min: number, max: number, svg: any) {
        const height = svg.height - svg.top - svg.bottom;
        if (min === max) return svg.top + height / 2;
        return svg.top + (1 - ((value - min) / (max - min))) * height;
    }

    private linearRegression(points: any[]) {
        if (points.length < 2) return null;
        const xAverage = this.average(points.map((point: any) => point[0]));
        const yAverage = this.average(points.map((point: any) => point[1]));
        if (xAverage === null || yAverage === null) return null;
        let numerator = 0;
        let denominator = 0;
        for (const [x, y] of points) {
            numerator += (x - xAverage) * (y - yAverage);
            denominator += Math.pow(x - xAverage, 2);
        }
        if (!denominator) return null;
        const slope = numerator / denominator;
        return { slope, intercept: yAverage - slope * xAverage };
    }

    private pearsonPValue(coefficient: number | null, count: number) {
        if (coefficient === null || count < 3) return null;
        const absolute = Math.abs(coefficient);
        if (absolute >= 1) return 0;
        if (count > 30) {
            const fisher = 0.5 * Math.log((1 + coefficient) / (1 - coefficient));
            const z = Math.abs(fisher) * Math.sqrt(count - 3);
            return Math.max(0, Math.min(1, 2 * (1 - this.normalCdf(z))));
        }
        const df = count - 2;
        const t = absolute * Math.sqrt(df / (1 - absolute * absolute));
        const cdf = this.studentTCdf(t, df);
        return Math.max(0, Math.min(1, 2 * (1 - cdf)));
    }

    private normalCdf(value: number) {
        return 0.5 * (1 + this.erf(value / Math.sqrt(2)));
    }

    private erf(value: number) {
        const sign = value < 0 ? -1 : 1;
        const x = Math.abs(value);
        const a1 = 0.254829592;
        const a2 = -0.284496736;
        const a3 = 1.421413741;
        const a4 = -1.453152027;
        const a5 = 1.061405429;
        const p = 0.3275911;
        const t = 1 / (1 + p * x);
        const y = 1 - (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t * Math.exp(-x * x);
        return sign * y;
    }

    private studentTCdf(t: number, df: number) {
        if (t === 0) return 0.5;
        const steps = 1200;
        const h = t / steps;
        let sum = this.studentTPdf(0, df) + this.studentTPdf(t, df);
        for (let index = 1; index < steps; index++) {
            sum += this.studentTPdf(index * h, df) * (index % 2 === 0 ? 2 : 4);
        }
        const area = (h / 3) * sum;
        return 0.5 + area;
    }

    private studentTPdf(t: number, df: number) {
        const numerator = Math.exp(this.logGamma((df + 1) / 2));
        const denominator = Math.sqrt(df * Math.PI) * Math.exp(this.logGamma(df / 2));
        return (numerator / denominator) * Math.pow(1 + (t * t) / df, -(df + 1) / 2);
    }

    private logGamma(value: number): number {
        const coefficients = [
            676.5203681218851,
            -1259.1392167224028,
            771.32342877765313,
            -176.61502916214059,
            12.507343278686905,
            -0.13857109526572012,
            9.9843695780195716e-6,
            1.5056327351493116e-7,
        ];
        if (value < 0.5) return Math.log(Math.PI) - Math.log(Math.sin(Math.PI * value)) - this.logGamma(1 - value);
        let x = 0.99999999999980993;
        const adjusted = value - 1;
        for (let index = 0; index < coefficients.length; index++) {
            x += coefficients[index] / (adjusted + index + 1);
        }
        const t = adjusted + coefficients.length - 0.5;
        return 0.5 * Math.log(2 * Math.PI) + (adjusted + 0.5) * Math.log(t) - t + Math.log(x);
    }
}

export default PageDashboardComponent;